//Componentes Generales
import React, { useState, useEffect, useContext, useRef } from 'react';
import NewProductItm from '../newProductItm/NewProductItm';
import SelectList from '../SelectList/SelectList';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { useMemo } from 'react';

//Contex
import productsContext from '../../context/productos/productsContext';
import reqsSectorsContext from '../../context/sectoresReqs/reqsSectorsContext';
import distribucionesContext from '../../context/distribuciones/distribucionesContext.js';
import warehousesContext from '../../context/depositos/warehousesContext';
import { ENTORNO } from '../../config/config.js';
import authContext from '../../context/authentication/authContex';

//Ruta para obtener sectores según depósito
import { getAbmWarehouseSectorsByDeposito } from '../../api/abmWarehouse.js';

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from '../../utils/priority';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

// Estilos
import './FormReq.css';

//Util
import { getMimeTypeFromFile } from '../../utils/files.js';
import Swal from 'sweetalert2';

// Constante con estructura del producto.
const createEstructuraProducto = () => ({
  tipPro: '',
  artCod: '',
  codRed: '',
  descrp: '',
  quantity: '1',
  textAdic: '',
  price: 0,
  abmCodDim: '',
  abmCodDimDescrp: '',
  abmSubCue: '',
  abmSubCueDescrp: '',
  usr_id: (Math.random() * 100).toString(),
});

const norm = v => `${v}`.replace(/\s+/g, '');

function FormReq({ edicion, req, files = [], itemList, guardarReq, cerrar }) {
  const [loading, setLoading] = useState(false);
  const [requeriment, setRequeriment] = useState(req);
  const [displayOptions, setDisplayOptions] = useState();
  const [items, setItems] = useState(
    itemList.length === 0
      ? [createEstructuraProducto()]
      : itemList
          .map(item => ({
            ...item,
            usr_id: item.usr_id || (Math.random() * 100).toString(),
          }))
          .concat([createEstructuraProducto()])
  );
  const [selectedFiles, setSelectedFiles] = useState(files);
  const [selectionColor, setSelectionColor] = useState(false);
  const [controlBotonEnviar, setControlBotonEnviar] = useState(false);
  const [warehouseSectors, setWarehouseSectors] = useState([]);
  const [warehouseChanged, setWarehouseChanged] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const pContext = useContext(productsContext);
  const { products, actualizarProducts } = pContext;

  const sRContext = useContext(reqsSectorsContext);
  const { reqsSectors, actualizarReqsSectors } = sRContext;

  const distContext = useContext(distribucionesContext);
  const {
    subcuentasDistribucion,
    actualizarSubcuentasDistribucion,
    distribuciones,
    actualizarDistribuciones,
  } = distContext;

  const dContext = useContext(warehousesContext);
  const { warehouses, actualizarWarehouses } = dContext;

  const aContext = useContext(authContext);
  const { usuario } = aContext;

  const inputFileRef = useRef(null);

  const navigate = useNavigate();

  const codDimTipoCosto =
    ENTORNO && ENTORNO.toLowerCase().includes('casport') ? 'TIPCOS' : 'TCC';
  const codDimCentroCosto =
    ENTORNO && ENTORNO.toLowerCase().includes('casport') ? 'CTRCTO' : 'CCO';

  const tiposCosto = useMemo(() => {
    const dimDescrp = (distribuciones || []).find(d => norm(d.codDim) === norm(codDimTipoCosto))?.codDimDescrp || '';
    return (subcuentasDistribucion || [])
      .filter(s => s.debaja !== 'S' && norm(s.codDim) === norm(codDimTipoCosto))
      .map(s => {
        const dist = (distribuciones || []).find(d => norm(d.codDim) === norm(s.codDim) && norm(d.codDis) === norm(s.codDis));
        return { ...s, codDimDescrp: dimDescrp, codDisDescrp: dist?.codDisDescrp || '' };
      });
  }, [subcuentasDistribucion, distribuciones, codDimTipoCosto]);

  const centrosCosto = useMemo(() => {
    const dimDescrp = (distribuciones || []).find(d => norm(d.codDim) === norm(codDimCentroCosto))?.codDimDescrp || '';
    return (subcuentasDistribucion || [])
      .filter(s => s.debaja !== 'S' && norm(s.codDim) === norm(codDimCentroCosto))
      .map(s => ({ ...s, codDimDescrp: dimDescrp }));
  }, [subcuentasDistribucion, distribuciones, codDimCentroCosto]);

  useEffect(() => {
    const fn = async () => {
      setLoading(true);
      try {
        await actualizarProducts();
        await actualizarReqsSectors();
        await actualizarSubcuentasDistribucion();
        await actualizarDistribuciones();
        await actualizarWarehouses();
        setDataLoaded(true);
      } catch (error) {
        console.error('Error al cargar los datos del contexto', error);
      } finally {
        setLoading(false);
      }
    };
    fn();
  }, []);

  useEffect(() => {
    if (
      !dataLoaded ||
      edicion === 'Edicion' ||
      !usuario ||
      !usuario.tDocAbmReqSectorCodsem
    )
      return;

    const preFill = async () => {
      try {
        const sectorReq =
          reqsSectors &&
          reqsSectors.find(
            s => norm(s.codSem) === norm(usuario.tDocAbmReqSectorCodsem)
          );
        const warehouse =
          warehouses &&
          warehouses.find(
            w => norm(w.deposi) === (norm(usuario.abmWarehouseDeposi) || '')
          );

        let warehouseSectorDescrp = '';
        let whSectors = [];
        if (usuario.abmWarehouseDeposi) {
          const respWS = await getAbmWarehouseSectorsByDeposito(
            usuario.abmWarehouseDeposi
          );
          whSectors = respWS.data.data || [];
          const ws = whSectors.find(
            s =>
              norm(s.sector) === (norm(usuario.abmWarehouseSectorSector) || '')
          );
          warehouseSectorDescrp = ws ? ws.descrp : '';
        }

        setWarehouseSectors(whSectors.filter(s => s.debaja !== 'S'));
        setRequeriment(prev => ({
          ...prev,
          tDocAbmReqSectorCodsem: usuario.tDocAbmReqSectorCodsem,
          tDocAbmReqSectorDescrp: sectorReq ? sectorReq.descrp : '',
          tDocAbmWarehouseDeposi: usuario.abmWarehouseDeposi || '',
          tDocAbmWarehouseDescrp: warehouse ? warehouse.descrp : '',
          tDocAbmWarehouseSectorSector: usuario.abmWarehouseSectorSector || '',
          tDocAbmWarehouseSectorDescrp: warehouseSectorDescrp,
        }));
      } catch (error) {
        console.error('Error al pre-rellenar datos del usuario', error);
      }
    };
    preFill();
  }, [dataLoaded, usuario]);

  const productosActivos = useMemo(
    () => products.filter(p => p.debaja !== 'S'),
    [products]
  );

  const reqsSectoresActivos = useMemo(
    () => (reqsSectors || []).filter(rS => rS.debaja !== 'S'),
    [reqsSectors]
  );

  const warehousesActivos = useMemo(
    () => (warehouses || []).filter(w => w.debaja !== 'S'),
    [warehouses]
  );

  const handleChangeTitle = data => {
    setRequeriment({ ...requeriment, title: data });
  };

  const handleChangeDate = (data, dateReason) => {
    const fecha = new Date(data.concat('T15:00:00.000Z'));
    setRequeriment({ ...requeriment, [dateReason]: fecha });
  };

  const handleChangObservation = data => {
    setRequeriment({ ...requeriment, observ: data });
  };

  const handleChangeReqSector = value => {
    const sectorReqSeleccionado = reqsSectors.find(
      rS => norm(rS.codSem) === norm(value.value.split(' ~ ')[0])
    );

    if (sectorReqSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        tDocAbmReqSectorCodsem: sectorReqSeleccionado.codSem,
        tDocAbmReqSectorDescrp: sectorReqSeleccionado.descrp,
      });
    }
  };

  const handleChangeWarehouse = async value => {
    setRequeriment(prevRequeriment => ({
      ...prevRequeriment,
      tDocAbmWarehouseDeposi: '',
      tDocAbmWarehouseSectorSector: '',
      tDocAbmWarehouseSectorDescrp: '',
    }));

    setWarehouseChanged(true);

    const depositoSeleccionado = warehouses.find(
      w => norm(w.deposi) === norm(value.value.split(' ~ ')[0])
    );

    if (depositoSeleccionado !== undefined) {
      const respWarehouseSectors = await getAbmWarehouseSectorsByDeposito(
        depositoSeleccionado.deposi
      );

      const sectores = (respWarehouseSectors.data.data || []).filter(s => s.debaja !== 'S');
      setWarehouseSectors(sectores);

      const primerSector = sectores.length > 0 ? sectores[0] : null;

      setRequeriment(prevRequeriment => ({
        ...prevRequeriment,
        tDocAbmWarehouseDeposi: depositoSeleccionado.deposi,
        tDocAbmWarehouseDescrp: depositoSeleccionado.descrp,
        tDocAbmWarehouseSectorSector: primerSector ? primerSector.sector : '',
        tDocAbmWarehouseSectorDescrp: primerSector ? primerSector.descrp : '',
      }));

      setWarehouseChanged(false);
    }
  };

  const handleChangeWarehouseSector = value => {
    setWarehouseChanged(false);
    const sectorDepositoSeleccionado = warehouseSectors.find(
      wS => norm(wS.sector) === norm(value.value.split(' ~ ')[0])
    );

    if (sectorDepositoSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        tDocAbmWarehouseSectorSector: sectorDepositoSeleccionado.sector,
        tDocAbmWarehouseSectorDescrp: sectorDepositoSeleccionado.descrp,
      });
    }
  };

  const ensureEmptyRow = list => {
    if (list.length === 0 || list[list.length - 1].artCod !== '') {
      return [...list, createEstructuraProducto()];
    }
    return list;
  };

  const addItem = (list, newItem) => {
    const cleanList = list.filter(i => i.artCod !== '');
    return [...cleanList, newItem];
  };

  const handleagregaItem = data => {
    const newItem = {
      ...data,
      usr_id: (Math.random() * 100).toString(),
    };

    setItems(prev => {
      const clean = prev.filter(i => i.artCod !== '');

      const updated = [...clean, newItem];

      return updated[updated.length - 1]?.artCod
        ? [...updated, createEstructuraProducto()]
        : updated;
    });
  };

  const handleDeleteConcept = (item, i) => {
    if (i !== items.length - 1) {
      setItems(items.filter((_, index) => index !== i));
    }
  };

  const handleChangeItm = (data, i) => {
    const newLista = items.map((it, index) => {
      return index === i ? data : it;
    });
    setItems(newLista);
  };

  const seleccionarPriority = priorIndex => {
    displayOpciones();
    setRequeriment({ ...requeriment, priority: priorIndex });
  };

  const displayOpciones = () => {
    displayOptions ? setDisplayOptions(false) : setDisplayOptions(true);
  };

  const handleFileInputChange = e => {
    if (e.target.files.length === 0) return;

    const files = Array.from(e.target.files);

    const validFiles = files.filter(file => {
      const detectedMimeType = getMimeTypeFromFile(file.name);

      // Validar tipo MIME permitido
      if (!detectedMimeType) {
        Swal.fire({
          title: 'Ops!',
          text: `Tipo de archivo no permitido o desconocido (${file.name})`,
          icon: 'error',
        });
        return false; // excluye el archivo
      }

      return true; // incluye el archivo válido
    });

    if (validFiles.length > 0) {
      setSelectedFiles(prev => [...prev, ...validFiles]);
    }

    // Limpia el input para poder volver a seleccionar los mismos archivos más tarde
    e.target.value = null;
  };

  const handleSaveRequirement = async () => {
    setControlBotonEnviar(true); // Bloqueo el botón mientras se esta enviando el requerimiento.
    const newLista = items.filter(d => d.artCod !== '');

    // 🔹 Procesar todos los archivos seleccionados antes de enviar
    const processedFiles = selectedFiles.map(file => {
      const name = file.name || '';
      const size = file.size || 0;
      const uri = file.uri || '';
      const mimeType = file.type || '';

      const safeName = name.replace(/[(){}\[\]áéíóúÁÉÍÓÚñÑ&#¿¡`^¨*]/g, '%');
      return {
        ...file,
        name: safeName,
        size,
        uri,
        type: mimeType,
      };
    });
    // Validar que las cantidades de centro de costo coincidan con la cantidad del producto
    for (const item of newLista) {
      if (item.centroCostoDistribucion) {
        const sumaSubcuentas = (
          item.centroCostoDistribucion.subcuentas || []
        ).reduce((acc, s) => acc + (parseFloat(s.cantidad) || 0), 0);
        if (Math.abs(sumaSubcuentas - item.quantity) > 0.001) {
          Swal.fire({
            title: 'Ops!',
            html: `La suma de las cantidades en Centro de Costo del producto: <strong>${item.descrp}</strong> debe ser igual a la cantidad del producto.`,
            icon: 'error',
          });
          setControlBotonEnviar(false);
          return;
        }
      }
    }

    // Construir accountingProration: siempre 2 registros por producto
    // Registro 1: TCC/TIPCOS (tipoCosto) — Registro 2: CCO/CTRCTO (centroCosto/centroCostoDistribucion)
    const accountingProration = newLista.flatMap((item, index) => {
      const records = [];
      const nroItm = index + 1;

      if (item.tipoCosto && item.tipoCosto.abmSubCue) {
        const tipoCostoDist = (distribuciones || []).find(
          d =>
            norm(d.codDim) === norm(item.tipoCosto?.abmCodDim) &&
            norm(d.codDis) === norm(item.tipoCosto?.abmCodDis)
        );
        records.push({
          codDim: item.tipoCosto.abmCodDim,
          codDimDescrp: item.tipoCosto.abmCodDimDescrp,
          codDis: tipoCostoDist?.codDis || item.tipoCosto.abmCodDis,
          codDisDescrp: tipoCostoDist?.codDisDescrp,
          productNroItm: nroItm,
          productTipPro: item.tipPro,
          productArtCod: item.artCod,
        });
      }

      if (item.centroCostoDistribucion?.distribucion) {
        const dist = item.centroCostoDistribucion.distribucion;
        records.push({
          codDim: dist.codDim,
          codDimDescrp: dist.codDimDescrp,
          codDis: dist.codDis,
          codDisDescrp: dist.codDisDescrp,
          productNroItm: nroItm,
          productTipPro: item.tipPro,
          productArtCod: item.artCod,
        });
      } else if (item.centroCostoDistribucion?.subcuentas?.length > 0) {
        records.push({
          codDim: item.centroCosto?.abmCodDim || codDimCentroCosto,
          codDimDescrp: item.centroCosto?.abmCodDimDescrp || '',
          codDis: '',
          codDisDescrp: '',
          productNroItm: nroItm,
          productTipPro: item.tipPro,
          productArtCod: item.artCod,
        });
      } else if (item.centroCosto && item.centroCosto.abmSubCue) {
        records.push({
          codDim: item.centroCosto.abmCodDim,
          codDimDescrp: item.centroCosto.abmCodDimDescrp,
          codDis: '',
          codDisDescrp: '',
          productNroItm: nroItm,
          productTipPro: item.tipPro || "",
          productArtCod: item.artCod || "",
        });
      }

      return records;
    });

    // Construir clientProration:
    // Registro 1: TCC/TIPCOS (tipoCosto) — Registros 2..N: CCO/CTRCTO (subcuentas de distribución)
    const clientProration = newLista.flatMap((item, index) => {
      const records = [];
      const nroItm = index + 1;

      if (item.tipoCosto && item.tipoCosto.abmSubCue) {
        records.push({
          codDim: item.tipoCosto.abmCodDim,
          subCue: item.tipoCosto.abmSubCue,
          subCueDescrp: item.tipoCosto.abmSubCueDescrp,
          cantidad: Number(item.quantity) || 0,
          proContNroItm: nroItm,
          productTipPro: item.tipPro,
          productArtCod: item.artCod,
        });
      }

      if (item.centroCostoDistribucion?.subcuentas?.length > 0) {
        const codDimCentro = item.centroCostoDistribucion.distribucion?.codDim || item.centroCosto?.abmCodDim || codDimCentroCosto;
        item.centroCostoDistribucion.subcuentas.forEach(sub => {
          records.push({
            codDim: codDimCentro,
            subCue: sub.subCue,
            subCueDescrp: sub.subCueDescrp,
            cantidad: Number(sub.cantidad) || 0,
            porcen: sub.porcen,
            proContNroItm: nroItm,
            productTipPro: item.tipPro,
            productArtCod: item.artCod,
          });
        });
      } else if (item.centroCosto && item.centroCosto.abmSubCue) {
        records.push({
          codDim: item.centroCosto.abmCodDim,
          subCue: item.centroCosto.abmSubCue,
          subCueDescrp: item.centroCosto.abmSubCueDescrp,
          cantidad: Number(item.quantity) || 0,
          proContNroItm: nroItm,
          productTipPro: item.tipPro,
          productArtCod: item.artCod,
        });
      }

      return records;
    });

    let resp;
    if (edicion === 'Edicion') {
      resp = await guardarReq(
        requeriment,
        newLista,
        selectedFiles,
        files,
        accountingProration,
        clientProration
      );
      setControlBotonEnviar(false); // Habilitar el botón nuevamente
      // Solo cerrar si la respuesta fue exitosa
      if (resp) {
        cerrar();
      }
    } else {
      resp = await guardarReq(
        requeriment,
        newLista,
        selectedFiles,
        accountingProration,
        clientProration
      );
      setControlBotonEnviar(false); // Habilitar el botón nuevamente
      if (resp) {
        setRequeriment({ ...req });
        setItems([createEstructuraProducto()]);
        setSelectedFiles([]);
        if (edicion == 'Guardar_Como') {
          cerrar();
        } else {
          navigate('/Home');
        }
      }
    }
  };

  /* 
        Manejador encargado de eliminar archivos al requerimiento.
            Donde aborrar es el archivo borrado por el usuario.
    */
  const eliminaFile = aborrar => {
    const array = Array.from(selectedFiles);
    setSelectedFiles(array.filter(data => data.name !== aborrar.name));
  };

  /*
        Función necesaria para poder personalizar input de files.
    */
  const cambioColorSeleccion = () => {
    setSelectionColor(!selectionColor);
  };

  const handleDescargarTemplate = () => {
    const wb = XLSX.utils.book_new();
    const wsData = [
      ['TIPPRO', 'ARTCOD', 'CANTID', 'TEXT ADIC'],
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Pre-formatear columnas de texto para preservar ceros al inicio (TIPPRO, ARTCOD)
    const textColIndices = [0, 1];
    const totalRows = 200;
    for (let r = 0; r < totalRows; r++) {
      for (const c of textColIndices) {
        const ref = XLSX.utils.encode_cell({ r, c });
        if (!ws[ref]) ws[ref] = { t: 's', v: '' };
        ws[ref].z = '@';
      }
    }
    ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: totalRows - 1, c: 3 } });

    XLSX.utils.book_append_sheet(wb, ws, 'Productos');
    XLSX.writeFile(wb, 'prodsReqXProvCASMOVI.xlsx', { cellStyles: true });
  };

  const handleFileXLSX = file => {
    if (file) {
      const reader = new FileReader();
      reader.onload = evt => {
        const binaryString = evt.target.result;
        const wb = XLSX.read(binaryString, { type: 'binary' });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        try {
          const firstRowTemplate = jsonData[0] ?? {};

          if (
            firstRowTemplate[0] != 'TIPPRO' ||
            firstRowTemplate[1] != 'ARTCOD' ||
            firstRowTemplate[2] != 'CANTID' ||
            firstRowTemplate[3] != 'TEXT ADIC'
          ) {
            Swal.fire({
              title: 'Ops!',
              html: 'Las columnas del archivo cargado no coinciden con las provistas por el template .xlsx.<br/>Por favor, descargue el template, complételo e intente nuevamente.',
              icon: 'error',
            });
            return;
          }

          const dataModelated = jsonData
            .filter((p, i) => i > 0 && p.length > 0)
            .map(p => {
              const productoSeleccionado = products.find(
                pr => norm(`${pr.tipPro}${pr.artCod}`) === norm(`${p[0]}${p[1]}`)
              );
              if (!productoSeleccionado) return undefined;

              return {
                tipPro:   productoSeleccionado.tipPro,
                artCod:   productoSeleccionado.artCod,
                descrp:   productoSeleccionado.descrp,
                price:    productoSeleccionado.price,
                uniMed:   productoSeleccionado.uniMed,
                quantity: p[2],
                textAdic: p[3],
                usr_id:   (Math.random() * 100).toString(),
              };
            })
            .filter(Boolean);

          setItems(prevItems => {
            const newItems = prevItems.filter(p => p.artCod);
            return [...newItems, ...dataModelated, { ...createEstructuraProducto() }];
          });
        } catch (error) {
          console.log('error intentando leer y cargar excel');
          console.log(error);
        }
      };
      reader.readAsBinaryString(file);
    }
  };

  const handleChangeXLSX = e => {
    const file = e.target.files[0];
    handleFileXLSX(file);
  };

  const handleDropXLSX = e => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    handleFileXLSX(droppedFile);
  };

  if (loading) {
    return (
      <div className="formreq-loading-overlay">
        <div className="formreq-spinner"></div>
      </div>
    );
  } else {
    return (
      <div className="container-gr-addreq">
        <div className="container-r-list-item-header">
          <input
            placeholder="Ingrese un título..."
            className="list-item-header-title-addReq"
            value={requeriment.title}
            onChange={data => handleChangeTitle(data.target.value)}
            autoFocus={true}
            style={{ fontWeight: 'bold' }}
            maxLength={60}
          ></input>
          <div className="container-prioritys-gral">
            <div
              className={
                requeriment.priority === 2
                  ? 'r-list-item-header-priority-urgente  margin-right-r'
                  : requeriment.priority === 1
                  ? 'r-list-item-header-priority-alta  margin-right-r'
                  : 'r-list-item-header-priority-media  margin-right-r'
              }
              onClick={displayOpciones}
            >
              {PRIORITY[requeriment.priority ? requeriment.priority : 0]}
            </div>
            {displayOptions && (
              <div className="options-container-fr  margin-right-r">
                <div className="options-container-fr-back">
                  {PRIORITY.map(prior => {
                    return (
                      <div
                        key={prior}
                        className={
                          PRIORITYIN[prior] === 2
                            ? 'r-list-item-header-priority-urgente'
                            : PRIORITYIN[prior] === 1
                            ? 'r-list-item-header-priority-alta'
                            : 'r-list-item-header-priority-media'
                        }
                        value={prior}
                        onClick={() => seleccionarPriority(PRIORITYIN[prior])}
                      >
                        {prior}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          {edicion && (
            <FontAwesomeIcon
              style={{ cursor: 'pointer' }}
              icon={faXmark}
              onClick={() => cerrar(null)}
            />
          )}
        </div>
        <div className="container-AddReq-item-gral">
          <div className="container-AddReq-item-details">
            <div className="container-r-item-title-details">
              Fecha de Entrega
            </div>
            <input
              type="date"
              className="label-AddReq-fecha"
              value={moment.utc(requeriment.deliveryDate).format('YYYY-MM-DD')}
              onChange={data =>
                handleChangeDate(data.target.value, 'deliveryDate')
              }
            />
          </div>
          <div
            className="container-AddReq-item-details"
            style={{ marginLeft: '80px' }}
          >
            <div className="container-r-item-title-details">
              Fecha de Movimiento
            </div>
            <input
              type="date"
              className="label-AddReq-fecha"
              value={moment.utc(requeriment.fchMov).format('YYYY-MM-DD')}
              onChange={data => handleChangeDate(data.target.value, 'fchMov')}
            />
          </div>
        </div>
        <div className="container-AddReq-item-details-text">
          <SelectList
            text={'Sector de Requerimientos'}
            options={reqsSectoresActivos.map(rS => {
              return {
                value: `${rS.codSem}`,
                label: `${rS.codSem}  (${rS.descrp})`,
              };
            })}
            handleChange={handleChangeReqSector}
            property={'Sector de Requerimientos'}
            valueAux={{
              label:
                requeriment.tDocAbmReqSectorCodsem &&
                requeriment.tDocAbmReqSectorDescrp
                  ? `${requeriment.tDocAbmReqSectorCodsem} (${requeriment.tDocAbmReqSectorDescrp})`
                  : '',
              value: requeriment.tDocAbmReqSectorCodsem || '',
            }}
            emptyInputs={[]}
          />
        </div>
        <div className="container-AddReq-item-details-text">
          <SelectList
            text={'Depósito'}
            options={warehousesActivos.map(w => {
              return {
                value: `${w.deposi}`,
                label: `${w.deposi}  (${w.descrp})`,
              };
            })}
            handleChange={handleChangeWarehouse}
            property={'Depósitos'}
            valueAux={{
              label:
                requeriment.tDocAbmWarehouseDeposi &&
                requeriment.tDocAbmWarehouseDescrp
                  ? `${requeriment.tDocAbmWarehouseDeposi} (${requeriment.tDocAbmWarehouseDescrp})`
                  : '',
              value: requeriment.tDocAbmWarehouseDeposi || '',
            }}
            emptyInputs={[]}
          />
        </div>
        <div
          className="container-AddReq-item-details-text"
          style={{ display: 'none' }}
        >
          <SelectList
            text={'Sector de Depósito'}
            options={warehouseSectors.map(wS => {
              return {
                value: `${wS.sector}`,
                label: `${wS.sector}  (${wS.descrp})`,
              };
            })}
            handleChange={handleChangeWarehouseSector}
            property={'Sectores de Depósito'}
            valueAux={{
              label:
                requeriment.tDocAbmWarehouseSectorSector &&
                requeriment.tDocAbmWarehouseSectorDescrp &&
                warehouseChanged === false
                  ? `${requeriment.tDocAbmWarehouseSectorSector} (${requeriment.tDocAbmWarehouseSectorDescrp})`
                  : '',
              value: requeriment.tDocAbmWarehouseSectorSector || '',
            }}
            emptyInputs={[]}
          />
        </div>
        <div className="container-AddReq-item-details-text">
          <div className="container-r-item-title-details">Texto Adicional</div>
          <div className="container-input-texto">
            <div className="r-text-adic">
              <textarea
                placeholder="Ingrese texto adicional"
                className="r-item-text-input"
                style={{ fontWeight: 600 }}
                value={requeriment.observ}
                onChange={data => handleChangObservation(data.target.value)}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="container-AddReq-item-details-items">
          <div className="container-r-item-title-details">
            Items: {items.length === 0 ? 0 : items.length - 1}
          </div>
          <div
            className="container-items-products-rq-gral"
            onDragOver={e => e.preventDefault()}
            onDrop={handleDropXLSX}
            style={{
              borderStyle: 'dotted',
              borderWidth: 4,
              borderColor: 'lightblue',
              padding: 4,
            }}
          >
            {items.length > 0 &&
              items.map((c, index) => {
                return (
                  <NewProductItm
                    data={c}
                    index={index}
                    key={c.usr_id}
                    edicion={edicion}
                    productsList={productosActivos}
                    agregaItem={data => handleagregaItem(data)}
                    modificaItm={(data, indice) =>
                      handleChangeItm(data, indice)
                    }
                    borraItem={() => handleDeleteConcept(c, index)}
                    tiposCosto={tiposCosto}
                    centrosCosto={centrosCosto}
                  />
                );
              })}
            <div className="handleExcelOptionsDiv">
              <button
                className="selectFileXLSXBtn"
                onClick={handleDescargarTemplate}
              >
                Descargar template.xlsx
              </button>
              <h5>
                <button
                  className="selectFileXLSXBtn"
                  onClick={() => inputFileRef.current.click()}
                >
                  Seleccione
                </button>{' '}
                o suelte en el area punteada un archivo .xlsx para cargar sus
                productos
              </h5>
              <input
                ref={inputFileRef}
                accept=".xlsx,.xls"
                type="file"
                onChange={e => handleChangeXLSX(e)}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </div>
        <div>
          <div className="container-button-rq-save-new2">
            <div
              className={
                selectionColor
                  ? 'button-rq-save-new2-selected'
                  : 'button-rq-save-new2'
              }
            >
              <div
                className="file-select"
                id="src-file1"
              >
                <input
                  onFocus={cambioColorSeleccion}
                  onBlur={cambioColorSeleccion}
                  type="file"
                  name="src-file1"
                  aria-label="Agregar Archivo"
                  multiple
                  onChange={handleFileInputChange}
                />
              </div>
            </div>
          </div>
          <div className="container-new-rq-files">
            <ul className="container-new-rq-files-details">
              {selectedFiles.map(file => (
                <li key={file.name}>
                  {file.name}
                  <FontAwesomeIcon
                    onClick={() => eliminaFile(file)}
                    style={{
                      cursor: 'pointer',
                      color: 'red',
                      marginLeft: '20px',
                    }}
                    icon={faXmark}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="container-button-rq-save-new">
          <button
            className="button-rq-save-new"
            disabled={controlBotonEnviar}
            onClick={handleSaveRequirement}
          >
            Finalizar
          </button>
        </div>
      </div>
    );
  }
}

export default FormReq;